
import { ViewComponent } from './View.Component';
export default ViewComponent;
